import { Routes, Route } from 'react-router-dom';
import './App.css';
import { Navbar,Home,About,Contact,Register,Signin, Errorpage,Logout } from './components';
import { createContext, useReducer } from 'react';
import { initialState, reducer } from './reducer/UseReducer';

export const UserContext = createContext();
function App() {
  
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <>
    <UserContext.Provider value={{state, dispatch}}>

      <Navbar/>
    <Routes>
    <Route path='*' element={<Errorpage />} />
      <Route exact path='/' element={<Home/>}/>
      <Route  path='/about' element={<About/>}/>
      <Route  path='/contact' element={<Contact/>}/>
      <Route  path='/register' element={<Register/>}/>
      <Route  path='/signin' element={<Signin/>}/>
      <Route  path='/logout' element={<Logout/>}/>

    </Routes>
    </UserContext.Provider>
    </>
  );
}

export default App;
